import { render, staticRenderFns } from "./loadSkeleton.vue?vue&type=template&id=74549650&scoped=true&"
var script = {}
import style0 from "./loadSkeleton.vue?vue&type=style&index=0&id=74549650&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74549650",
  null
  
)

export default component.exports